export enum ApprovalStatus
{
    Default = 0,
    Pending,
    PartiallyApproved, 
    Approved,
    Declined,
    Queued
}
export enum ApprovalType
{
    None = 0,
    EstimateApproval,
    SalesOrderApproval,
    InvoiceApproval
}

export enum ApprovalListType
 {
 	Default = 0,
 	MyInitiation,
 	MyApproval,
 	OtherApproval
 }